import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import { sanitize } from 'isomorphic-dompurify';

import * as icons from '@gn-audio/icons';
import { Button, JabraIcon } from '@gn-audio/jss-components';

import { DualColumnPromoItem } from './dualColumnPromoTypes';

const PromoItem = ({ item }: { item: DualColumnPromoItem }) => {
  const {
    image,
    headline,
    description,
    firstButtonLink,
    firstButtonText,
    firstButtonVariant,
    firstButtonIcon,
    firstButtonAriaLabel,
    secondButtonLink,
    secondButtonText,
    secondButtonVariant,
    secondButtonIcon,
    secondButtonAriaLabel,
    firstCtaButtonTrackingItemName,
    secondCtaButtonTrackingItemName,
  } = item;

  return (
    <article className="flex flex-col items-start">
      <Image field={image} className="mb-6 rounded-3xl" loading="lazy" />
      {!!headline.value && (
        <h3
          className="heading-3 mb-6"
          dangerouslySetInnerHTML={{ __html: sanitize(headline.value as string) }}
        />
      )}
      {!!description.value && (
        <p
          className="paragraph mb-6"
          dangerouslySetInnerHTML={{ __html: sanitize(description.value as string) }}
        />
      )}
      <section className="flex flex-col flex-wrap gap-6 md:flex-row">
        {!!firstButtonLink.value?.href && !!firstButtonText.value && (
          <Button
            asLink
            href={firstButtonLink.value.href}
            size="m"
            {...(firstButtonAriaLabel?.value && {
              'aria-label': firstButtonAriaLabel.value,
            })}
            variant={firstButtonVariant.value || 'primary'}
            {...(firstButtonIcon?.value && {
              icon: <JabraIcon Icon={icons?.[firstButtonIcon.value]} />,
              iconPlacement: 'right',
            })}
            {...(firstCtaButtonTrackingItemName?.value && {
              'data-wt-name': firstCtaButtonTrackingItemName.value,
            })}
          >
            {firstButtonText.value}
          </Button>
        )}
        {!!secondButtonLink.value?.href && !!secondButtonText.value && (
          <Button
            asLink
            href={secondButtonLink.value.href}
            size="m"
            {...(secondButtonAriaLabel?.value && {
              'aria-label': secondButtonAriaLabel.value,
            })}
            variant={secondButtonVariant.value || 'secondary'}
            {...(secondButtonIcon?.value && {
              icon: <JabraIcon Icon={icons?.[secondButtonIcon.value]} />,
              iconPlacement: 'right',
            })}
            {...(secondCtaButtonTrackingItemName?.value && {
              'data-wt-name': secondCtaButtonTrackingItemName.value,
            })}
          >
            {secondButtonText.value}
          </Button>
        )}
      </section>
    </article>
  );
};
export default PromoItem;
